import {
  ComponentLabel,
  UiZoneWidgetConfig,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export const mapImageOrCarousalSectionsFunction = mapImageOrCarousalSectionsV2;
export function mapImageOrCarousalSectionsV2(item: WorkflowWidgetConfig): UiZoneWidgetConfig {
  const elementConfig = item.widgetConfiguration.attributes.elementsConfig[0];
  const fieldAttributesArray = [];
  for (const fieldAttributes of elementConfig.options) {
    fieldAttributesArray.push({
      name: fieldAttributes.field_name,
      type: fieldAttributes.type,
      label: fieldAttributes.label,
      options: [],
      additional_config: {
        id: fieldAttributes.id,
        show: fieldAttributes.show,
        position: fieldAttributes.position,
      },
    });
  }

  const attributes = {
    show: elementConfig.show,
    label: elementConfig.label,
    field_attributes: fieldAttributesArray,
    timer: elementConfig.timer,
  };
  return {
    name: item.name as ComponentLabel,
    attributes: Object.assign(attributes, item.widgetConfiguration.attributes),
    uniqueId: item.uniqueId,
    gridPosition: item.gridPosition,
  };
}
